const Types = {
    "SET_FEEDBACK": "SET_FEEDBACK",
    "SHOW_CONTACT": "SHOW_CONTACT",
    "SHOW_WORKSHOP": "SHOW_WORKSHOP",
    "SET_SELECTED_ITEM": "SET_SELECTED_ITEM",
    "SET_PAGE": "SET_PAGE",
}

export default Types